module.exports = __webpack_public_path__ + "static/media/close-white.e0a4769e.svg";